export enum LanguagesEnum {
    Russian = 'ru',
    // English = 'en',
}

// export enum CultureLanguagesEnum {
//   russian = 'ru-RU',
//   english = 'en-US',
// }
